import React, { Component } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import {
  Button,
  Icon,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import "date-fns";
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DateFnsUtils from '@date-io/date-fns';
import useAutocomplete from '@material-ui/lab/useAutocomplete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import OrganizationService from './../../../services/OrganizationService';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';
import { SimpleCard } from "matx";
import * as appVariables from './../../../appVariables';
import { withStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';

const styles = theme => ({
  cssLabel: {
    color: 'red'
  },

  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: `${theme.palette.primary.main} !important`,
    }
  },

  cssFocused: {},

  notchedOutline: {
    borderWidth: '1px',
    borderColor: 'blue !important'
  },

});
class Organizationtlist extends Component {
  state = {
    snakebar: false,
    message: "",
    severity: "success",
    formdata: { 
      name: "" ,
      type:""
    },
  };
  componentDidMount() {

  }



  //Add form data
  handleChange = event => {
    event.persist();
    var data = this.state.formdata;

    data[event.target.name] = event.target.value;
    this.setState({
      formdata: data
    });


  };

  setdropdowndata(key, value) {
    var data = this.state.formdata;
    if (value == null) {
      data[key] = "";
      this.setState({ formdata: data });
    } else {
      data[key] = value.title;
      this.setState({ formdata: data });
    }
  }

  //Create new  organization
  handleFormSubmit = event => {
    var data = this.state.formdata;

    OrganizationService.createOrganization(data).then(res => {
      if (res.status == 200) {
        this.setState({ message: res.data.message, snakebar: true, severity: "success" })
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        this.setState({ message: "Can not create Organization", snakebar: true, severity: "error" })
      }
    })
      .catch((error) => {
        console.log("error", error);
      })

  }


  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snakebar: false })

  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <SimpleCard title="Organization">
          <ValidatorForm
            ref="form"
            onSubmit={this.handleFormSubmit}>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <TextValidator
                  className="mb-16 w-100"
                  placeholder="Organization"
                  name="name"
                  size="small"
                  value={this.state.formdata.name}
                  onChange={(e)=>{
                    if(e.target.value !== null){
                      this.setState({
                        formdata:{
                          ...this.state.formdata,
                          name:e.target.value
                        }
                      })
                    }else{
                      this.setState({
                        formdata:{
                          ...this.state.formdata,
                          name:null
                        }
                      })
                    }
                  }}
                  // error
                  helperText="Required Field "
                  variant="outlined"
                  validators={[
                    "required"
                  ]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  disableClearable
                  className="mb-24 w-100"
                  size='small'
                  name="type"
                  options={appVariables.organization_types}
                  getOptionLabel={(option) => option.title}
                  getOptionSelected={(opt,value)=>opt.value === value.value}
                  onChange={(event, value) => {
                      console.log('oo',value)
                      // this.respondentsdropdowndata(index, "district", value)
                      if(value != null){
                          this.setState({
                              formdata:{
                                ...this.state.formdata,
                                type:value.value,
                              }
                            })
                          }else{
                            this.setState({
                              formdata:{
                                ...this.state.formdata,
                                type:null,
                              }
                          })
                      }
                  }}
                  renderInput={(params) => 
                  <TextField 
                      {...params} 
                      label="Organization Type" 
                      variant="outlined" 
                      value={this.state.formdata?.type}
                  />}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Save
            </Button>
          </ValidatorForm>
        </SimpleCard>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={this.state.snakebar} autoHideDuration={2500} onClose={this.handleClose}>
          <Alert onClose={this.handleClose} severity={this.state.severity}>
            {this.state.message}
          </Alert>
        </Snackbar>

      </div>

    );
  };
}


Organizationtlist.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(Organizationtlist);
